<template>
  <b-modal v-model="show" size="lg" centered scrollable no-close-on-backdrop header-class="bg-modal-header">

    <template #modal-header>
      <div class="fw-bold">금일 장애 현황</div>
    </template>

    <div class="row">
      <div class="col-4">
        <multiselect id="searchEvseId" style="z-index: 5"
                     v-model="selectedCsId" :options="evseOptions"
                     label="csoEvseNum" placeholder="충전기 ID" select-label=""
                     :allow-empty="true" :max-height="202">
          <span slot="noResult">No Result</span>
        </multiselect>
      </div>
      <div class="col-5">
        <multiselect id="failureCode" style="z-index: 5"
                     v-model="selectedFailure" :options="failureList"
                     label="errorCode" placeholder="에러 유형" select-label=""
                     :allow-empty="false" :custom-label="transformedCode"
                     :max-height="202">
          <span slot="noResult">No Result</span>

        </multiselect>
      </div>
      <div class="col text-align-end">
        <b-button @click="reset">
          <i class="fas fa-redo icon-padding-right ct-mb-padding-left-25"/>
          <span class="d-none d-sm-inline-block">초기화</span>
        </b-button>
      </div>
    </div>

    <hr/>
    <vue-custom-scrollbar>
      <MDKTable
          :fields="fields"
          :items="items"
          style="height: 60vh"
          :sticky-header="true"
          :hide-filter-row="true"
      >
        <template #cell(errorCode)="props">
          {{$_app.code.errorCode[props.item.errorCode]}}
        </template>
        <template #cell(vendorErrorCode)="props">
          {{$_app.code.vendorErrorCode[props.item.vendorErrorCode]}}
        </template>
      </MDKTable>
    </vue-custom-scrollbar>

    <template #modal-footer>
      <div class="w-100">
        <b-button variant="secondary" class="float-end w-xs p-1" @click="show=false">닫기</b-button>
      </div>
    </template>

  </b-modal>
</template>

<script>
import vueCustomScrollbar from 'vue-custom-scrollbar';
import Multiselect from "vue-multiselect";

export default {
  name: "FailureModal",
  props: {
    placeId: String,
    today: String,
    failureList: Array,
    evseOptions: Array
  },
  components: {
    Multiselect,
    vueCustomScrollbar
  },
  data() {
    const _eApi = this.$_app.service.evseUse;
    return {
      eApi: _eApi,
      failureOptions: [],
      selectedCsId: null,
      selectedFailure: null,
      show: false,
      fields: [
          _eApi.schema.csoEvseNum,
          _eApi.schema.errorCode,
          _eApi.schema.vendorErrorCode,
          _eApi.schema.notiTime,
      ],
      items: [],
      originalItems: [],
    }
  },
  watch: {
    placeId: {
      immediate: true,
      handler() {
        this.getList()
      }
    },
    selectedCsId: {
      handler() {
        if(!this.selectedCsId) {
          this.items = [...this.originalItems];
          return;
        }
        const arr = this.originalItems.filter(item => item.csoEvseNum == this.selectedCsId.csoEvseNum)

        if(arr.length !== 0) {
          this.items = arr;
        } else {
          this.items = [];
        }
      }
    },
    selectedFailure: {
      handler() {
        if(!this.selectedFailure) {
          this.items = [...this.originalItems];
          return;
        }
        const arr = this.originalItems.filter(item => item.errorCode == this.selectedFailure.errorCode)

        if(arr.length !== 0) {
          this.items = arr;
        } else {
          this.items = [];
        }
      }
    },
    // failureList: {
    //   deep: true,
    //   handler() {
    //     this.getFailure();
    //   }
    // },
    show: {
      handler(val) {
        const vm = this;

        if (val===false) {
          vm.reset();
        }
      }
    }
  },
  methods: {
    getList() {
      const vm = this;
      if(!vm.placeId) {
        return;
      }
      vm.eApi.requestFailureModalList(vm.placeId, vm.today)
          .then(res => {
            vm.items = [...res.items];
            vm.originalItems = [...res.items];
          })
    },
    // getFailure() {
    //   const vm = this;
    //
    //   vm.eApi.schema.failure.dropdownOptions = {};
    //
    //   vm.failureList.forEach(item => {
    //     vm.eApi.schema.failure.dropdownOptions[item.errorCode] = vm.$_app.code.errorCode[item.errorCode]
    //   })
    // },
    reset() {
      const vm = this;

      vm.selectedCsId = '';
      vm.selectedFailure = '';
    },
    transformedCode({errorCode}) {
      const vm = this;

      return vm.$_app.code.errorCode[errorCode];
    }
  },
}
</script>

<style scoped lang="scss">
::v-deep {
  .form-control:disabled, .form-control:read-only {
    background-color: #FFF;
  }
  table#mdk-table > thead > tr > th {
    background-color: #003953;
    color: white;
    word-break: keep-all;
  }
  table#mdk-table > tbody {
    text-align: center;
  }
}
</style>